"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.defaultLocale = void 0;
exports.defaultLocale = 'ru';
var backgroundColorBase = '#F5F5F5';
var backgroundColorAccent = '#FFFFFF';
var borderColorBase = '#E0E0E0';
var panelFooterHeight = '60px';
var panelDetailsHeight = '400px';
var borderRadiusBase = '4px';
var colorSuccess = '#27AE60';
var colorSuccessDarker = '#1F9D54';
var backgroundColorSuccess = '#D8F4D1';
var colorError = '#EB5757';
var colorErrorDarker = '#D54747';
var backgroundColorError = '#FFDEDE';
var backgroundColorSelected = '#EEF9FF';
var colorDisabled = '#C6C6C6';
var colorBlack = '#222222';
var colorBlackLight = '#63666a';
var backgroundColorWarning = '#FDFAEE';
var colorWarning = '#F2C94C';
exports.defaultTheme = {
    fontSizeSmaller: '12px',
    borderColorBase: borderColorBase,
    borderBase: "1px solid " + borderColorBase,
    borderRadiusBase: borderRadiusBase,
    backgroundColorBase: backgroundColorBase,
    backgroundColorAccent: backgroundColorAccent,
    colorSuccess: colorSuccess,
    colorSuccessDarker: colorSuccessDarker,
    backgroundColorSuccess: backgroundColorSuccess,
    colorError: colorError,
    colorErrorDarker: colorErrorDarker,
    backgroundColorError: backgroundColorError,
    backgroundColorSelected: backgroundColorSelected,
    colorDisabled: colorDisabled,
    colorBlack: colorBlack,
    colorBlackLight: colorBlackLight,
    backgroundColorWarning: backgroundColorWarning,
    colorWarning: colorWarning,
    panelFooterHeight: panelFooterHeight,
    panelDetailsHeight: panelDetailsHeight,
    collisionPopoverWidth: '350px',
    management: {
        paddingVertical: '6px',
        paddingHorizontal: '12px',
        participantResolutionPaddingRight: '6px',
        participantResolutionSize: '24px',
        groupOffsetRight: '24px',
        groupActionButtonSize: '36px',
        chipIconSize: '16px',
    },
};
